import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles((theme) => ({
  starsContainer: {
    marginTop: theme.spacing(1.5),
  },
  star: {
    cursor: "pointer",
    fontSize: "2em",
    fill: theme.palette.icon.primary,
  },
  starSelected: {
    cursor: "pointer",
    fill: theme.palette.yellow.dark,
    fontSize: "2em",
  },
  ratingText: {
    display: "inline-block",
    marginTop: theme.spacing(1),
    color: theme.palette.text.primary,
  },
  submitContainer: {
    paddingTop: theme.spacing(1.5),
  },
}));
